import Cookies from 'js-cookie';
import { serverTrackAndIdentify } from 'utils/segment';
import { getStateStatus } from 'utils/states';
import { browserWindow } from 'utils/window';

import { formatPhoneNumberPortals } from './fitQuizDataUtils';

export const trackQuizData = (step, data, result) => {
  const utmData = Cookies.getJSON('ht_utm_data') || {};
  return serverTrackAndIdentify(
    {
      event: 'Engagement Form Completed',
      eventProperties: {
        form_name: 'fit quiz',
        version: '2.2',
        version_start_date: '09-21-2020',
        page_url: browserWindow.location.hostname,
        step: step,
        result: result,

        // Basic Form
        homeowner_status: data.homeowner_status,
        own_home: data.is_homeowner,
        state: data.state,
        state_status: data.state ? getStateStatus(data.state) : undefined,

        // Use Case Form
        primary_use_case: data.use_case,

        // Finance Form
        ideal_investment_amount: data.ideal_investment_amount,
        alternatives_considered: data.alternatives_considered && data.alternatives_considered.join(', '),
        rainy_day_fund: data.rainy_day_fund,
        monthly_expenses_concern: data.monthly_expenses_concern ? data.monthly_expenses_concern === 'yes' : undefined,
        ten_year_duration_prediction: data.term,

        // Personal Form
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email?.toLowerCase(),
        phone: data.phone,

        // UTM Data
        fit_quiz_gclid: utmData.gclid,
        fit_quiz_referrer: utmData.referrer,
        fit_quiz_referring_domain: utmData.referring_domain,
        fit_quiz_utm_source: utmData.utm_source,
        fit_quiz_utm_campaign: utmData.utm_campaign,
        fit_quiz_utm_content: utmData.utm_content,
        fit_quiz_utm_medium: utmData.utm_medium,
        fit_quiz_utm_term: utmData.utm_term,
      },
      userId: data.email,
      userProperties: data.email && {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone: data.phone,
      },
    },
    { sendToSalesforce: step === 5 },
  );
};

export const setFitQuizCookie = (data) => {
  const formattedNumber = formatPhoneNumberPortals(data.phone);

  Cookies.set(
    'ht_fit_quiz_data',
    {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      phone_number: formattedNumber == null ? undefined : formattedNumber,
      primary_use_case: data.use_case,
      state: data.state,
    },
    {
      expires: 365,
      domain: browserWindow.location.hostname === 'www.hometap.com' ? '.hometap.com' : browserWindow.location.hostname,
    },
  );
};
